/*global FakeCation*/
(function (FC) {
"use strict";

  FC.utils.registerFilter('invert', function (imgData, cb) {
    var i, data = imgData.data, color;

    for (i = 0; i < data.length; i += 4) {
      color = new FC.colorUtils.Color(data[i], data[i+1], data[i+2]);
      color = color.invert();

      data[i] = color.red;
      data[i+1] = color.green;
      data[i+2] = color.blue;
    }

    cb(imgData);
  });
}(FakeCation));
